import { getNextApiRoute, typedFetch } from '@libs/common-next';
import {
    ResultEstimateAPISchema,
    type DoorDashAPIBody,
    type ResultEstimateAPI,
} from '@libs/doordash';
import { HttpMethod, type Nullable } from '@libs/core';

export const getEstimationDelivery = async (
    data: DoorDashAPIBody
): Promise<Nullable<ResultEstimateAPI>> =>
    await typedFetch<ResultEstimateAPI>(
        getNextApiRoute(`estimation`),
        {
            headers: {
                accept: 'application/json',
                'content-type': 'application/json',
            },
            body: JSON.stringify(data),
            method: HttpMethod.POST,
        },
        ResultEstimateAPISchema
    );
